// EMBER 8 OFFERINGS PAGE - ADD TO CART FUNCTIONALITY
// This file handles all "Add to Cart" buttons on the offerings page

// Product Variant IDs (these are the unique identifiers Shopify uses)
const VARIANT_IDS = {
  tier1: '52294828949717',
  tier2: '52284194947285',
  tier3: '52294842810581',
  calibrate: '52284723265749'
};

// Main function to add items to cart
function addToCart(variantId, productName) {
  // Show loading state (optional - makes button say "Adding...")
  const clickedButton = event.target;
  const originalText = clickedButton.textContent;
  clickedButton.textContent = 'Adding...';
  clickedButton.disabled = true;
  
  // Make the API call to Shopify's cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    // Success! Redirect to cart page
    window.location.href = '/cart';
  })
  .catch(error => {
    // Error handling
    console.error('Error adding to cart:', error);
    alert('There was an error adding ' + productName + ' to your cart. Please try again or contact support.');
    
    // Reset button
    clickedButton.textContent = originalText;
    clickedButton.disabled = false;
  });
}

// Individual functions for each tier (called by your HTML buttons)
function addTier1ToCart() {
  addToCart(VARIANT_IDS.tier1, 'Tier 1 - The Insight');
}

function addTier2ToCart() {
  addToCart(VARIANT_IDS.tier2, 'Tier 2 - The Evolution');
}

function addTier3ToCart() {
  addToCart(VARIANT_IDS.tier3, 'Tier 3 - The Revolution');
}

function addCalibrateToCart() {
  addToCart(VARIANT_IDS.calibrate, 'Calibrate Check-In Package');
}

// Optional: Function to add multiple items at once (for future use with add-ons)
function addMultipleToCart(variantIds, productName) {
  const items = variantIds.map(id => ({
    id: id,
    quantity: 1
  }));
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ items: items })
  })
  .then(response => response.json())
  .then(data => {
    window.location.href = '/cart';
  })
  .catch(error => {
    console.error('Error:', error);
    alert('Unable to add items to cart. Please try again.');
  });
}

// Console message for debugging
console.log('Ember 8 Offerings Cart - Loaded successfully');
console.log('Available functions: addTier1ToCart(), addTier2ToCart(), addTier3ToCart(), addCalibrateToCart()');